import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import classNames from "classnames";

// Context
import { useAuth } from "./context/useAuth";
import Sidebar from "./components/common/Sidebar";

// Pages
import Login from "./pages/Login";
import UserList from "./pages/UserList";
import RoleManagement from "./pages/RoleManagement";
import OrgChart from "./pages/OrgChart";

export default function RoutesApp() {
  let auth = useAuth();
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(true);

  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    auth.checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={"main-wrapper" + (auth.user ? " logged" : " hide-sidebar") + (sidebarVisible ? "" : " hide-sidebar")}>
      <Sidebar sidebarVisible={sidebarVisible} />
      <div className="page-container">
        <Routes>
          {auth.user ? (
            <>
              <Route path="/" element={<OrgChart />} />
              <Route path="/user" element={<UserList />} />
              <Route path="/settings/roles" element={<RoleManagement />} />
              <Route path="/orgchart" element={<OrgChart />} />
            </>
          ) : (
            <Route path="*" element={<Login />} />
          )}
        </Routes>
      </div>
      {auth.user && (
        <button
          className={classNames("btn-sidebar-toggle-fixed", sidebarVisible ? "sidebar-open" : "sidebar-closed")}
          onClick={() => setSidebarVisible((prev) => !prev)}
          aria-label={sidebarVisible ? "Hide sidebar" : "Show sidebar"}
        >
          <i className="material-icons">{sidebarVisible ? "chevron_left" : "chevron_right"}</i>
        </button>
      )}
    </div>
  );
}
